.ac-root {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 16px;
    box-sizing: border-box;
    color: #0a1f30;
    font-family: inherit;
}
.ac-root * {
    box-sizing: border-box;
}
.ac-card {
    display: grid;
    align-content: center;
    width: 100%;
    max-width: 680px;
    min-width: 0;
    min-height: 380px;
    margin: 0 auto;
    padding: 28px 20px;
    overflow: hidden;
    background: var(--ac-surface);
    border: 1px solid rgba(10,31,48,.13);
    border-radius: var(--ac-radius);
    box-shadow: 0 16px 48px rgba(10,31,48,.08);
    text-align: center;
}
.ac-icon {
    display: grid;
    place-items: center;
    width: 60px;
    height: 60px;
    margin: 0 auto 18px;
    border-radius: 6px;
    background: #e6f8ef;
    color: #087444;
    font-weight: 900;
    font-size: 29px;
}
.ac-warning {
    background: #fff5dc;
    color: #8a5a00;
}
.ac-logo {
    width: 76px;
    height: 76px;
    margin: 0 auto 16px;
    object-fit: contain;
}
.ac-eyebrow {
    color: var(--ac-primary);
    font-size: 11px;
    font-weight: 850;
    letter-spacing: .14em;
}
.ac-card h2 {
    max-width: 520px;
    margin: 7px auto 10px;
    font-size: clamp(27px,8vw,42px);
    line-height: 1.08;
    letter-spacing: -.035em;
}
.ac-card>p,.ac-loading p {
    color: #61717d;
    max-width: 540px;
    margin-inline: auto;
}
.ac-reference {
    margin-block: 0 24px!important;
}
.ac-reference strong {
    color: #0a1f30;
}
.ac-status-message {
    margin-block: -10px 20px!important;
    padding: 11px 12px;
    border-radius: 6px;
    background: #fff7df;
    color: #6f5000!important;
    font-size: 13px;
}
.ac-receipt {
    display: grid;
    width: 100%;
    min-width: 0;
    text-align: left;
    border: 1px solid rgba(10,31,48,.13);
    border-radius: 6px;
    overflow: hidden;
}
.ac-equipment,.ac-receipt-section {
    min-width: 0;
    padding: 16px;
}
.ac-receipt-section {
    border-top: 1px solid rgba(10,31,48,.12);
}
.ac-product {
    display: grid;
    grid-template-columns: 52px minmax(0,1fr);
    align-items: center;
    gap: 12px;
}
.ac-product-image {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid rgba(10,31,48,.12);
    border-radius: 6px;
    background: #fff;
}
.ac-product-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: inherit;
}
.ac-product-image b {
    position: absolute;
    right: -4px;
    bottom: -4px;
    display: grid;
    place-items: center;
    min-width: 19px;
    height: 19px;
    padding: 0 4px;
    border: 2px solid #fff;
    border-radius: 6px;
    background: var(--ac-primary);
    color: #fff;
    font-size: 10px;
}
.ac-product>strong {
    min-width: 0;
    font-size: 16px;
    line-height: 1.25;
}
.ac-rows {
    display: grid;
    margin: 15px 0 0;
}
.ac-rows div {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 0;
    border-top: 1px solid rgba(10,31,48,.09);
}
.ac-rows dt,.ac-rows dd {
    font-size: 13px;
}
.ac-rows dt {
    color: #61717d;
}
.ac-rows dd {
    margin: 0;
    font-weight: 750;
    text-align: right;
}
.ac-receipt h3 {
    margin: 0 0 9px;
    font-size: 13px;
}
.ac-receipt address {
    color: #334b57;
    font-size: 14px;
    line-height: 1.5;
    font-style: normal;
}
.ac-payment-rows {
    display: grid;
    gap: 9px;
}
.ac-payment-rows>div,.ac-paid {
    display: flex;
    justify-content: space-between;
    gap: 16px;
}
.ac-payment-rows>div {
    font-size: 13px;
}
.ac-free {
    color: #13824b;
}
.ac-paid {
    align-items: center;
    margin-top: 13px;
    padding-top: 13px;
    border-top: 1px solid rgba(10,31,48,.13);
    font-size: 18px;
}
.ac-paid strong {
    color: var(--ac-primary);
    font-size: 21px;
}
.ac-contact {
    margin-block: 22px 0!important;
    font-size: 13px;
    line-height: 1.55;
}
.ac-contact a {
    color: var(--ac-primary);
    font-weight: 750;
    overflow-wrap: anywhere;
}
.ac-support {
    display: flex;
    justify-content: center;
    gap: 9px;
    flex-wrap: wrap;
}
.ac-status-actions {
    margin: 0 0 20px;
    font-size: 13px;
    color: #61717d;
}
.ac-retry {
    justify-self: center;
    padding: 12px 20px;
    border: 1px solid rgba(10,31,48,.18);
    border-radius: 6px;
    background: #fff;
    color: var(--ac-primary);
    font: inherit;
    font-weight: 750;
    cursor: pointer;
}
.ac-retry:disabled { cursor: wait; opacity: .6; }
.ac-support a {
    display: grid;
    place-items: center;
    min-height: 48px;
    padding: 0 16px;
    border: 1px solid rgba(10,31,48,.18);
    border-radius: 6px;
    color: inherit;
    font-weight: 750;
    text-decoration: none;
}
.ac-loading span {
    display: block;
    width: 36px;
    height: 36px;
    margin: 0 auto 18px;
    border: 3px solid color-mix(in srgb,var(--ac-primary) 18%,transparent);
    border-top-color: var(--ac-primary);
    border-radius: 6px;
    animation: ac-spin .75s linear infinite;
}
@keyframes ac-spin {
    to {
        transform: rotate(360deg);
    }
}
@media(min-width:640px) {
    .ac-root {
        padding: 28px;
    }
    .ac-card {
        padding: 42px;
    }
    .ac-equipment,.ac-receipt-section {
        padding: 19px 20px;
    }
}
@media(prefers-reduced-motion:reduce) {
    .ac-loading span {
        animation-duration: .001ms;
    }
}
